import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { t } from "@/i18n/sk";

export default function PaymentCancel() {
  return (
    <div className="vault-bg">
      <section className="mx-auto flex max-w-xl flex-col items-center gap-5 px-4 py-24 text-center" data-testid="payment-cancel">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/15">
          <XCircle className="h-9 w-9 text-amber-400" />
        </div>
        <h1 className="font-display text-2xl font-bold text-white">{t.payment.cancelTitle}</h1>
        <p className="max-w-md text-slate-300">{t.payment.cancelDesc}</p>
        <div className="mt-2 flex gap-3">
          <Link to="/pokladna" data-testid="cancel-retry" className="btn-glow rounded-full bg-gradient-to-r from-violet-glow to-cyan-glow px-6 py-2.5 text-sm font-semibold text-white">
            {t.payment.backToCart}
          </Link>
          <Link to="/" className="rounded-full border border-white/10 px-6 py-2.5 text-sm text-slate-200 hover:bg-white/5">
            {t.payment.continueShopping}
          </Link>
        </div>
      </section>
    </div>
  );
}
